// Vendors
import $ from 'jquery';

let email = $('#emailPartList');
let submit = $('#emailSubmit');

submit.on('click', event => validateEmail(event));

function validateEmail(event) {
  event.preventDefault();
  let error = false;
  let input = email.find('.form__input');
  let emailRegex = new RegExp(
    /^[+a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/i
  );

  if (input.val() == '' || emailRegex.test(input.val()) !== true) {
    error = true;
    handleError(input, error);
  } else {
    error = false;
    handleError(input, error);
  }
}

function handleError(input, error) {
  let parent = input.parent();
  let child = email.find('.form__help');

  if (error === true) {
    parent.addClass('form__field--error');
    input.focus();
    child.empty();
    input.after("<small class='form__help'>Error: Enter Valid Email</small>");
  } else if (error === false) {
    parent.removeClass('form__field--error');
    parent.addClass('form__field--success');
    input.focus();
    child.empty();
    input.after("<small class='form__help'>Success: Email Sent</small>");

    email.submit();
  }
}
